import React, { useState, useEffect } from 'react';
import { getUserData } from '../../services/API';
import Video from '../Student/Dyslexia/Video';
import FaRepeat from 'react-icons/lib/fa/repeat';
import FaPaperPlane from 'react-icons/lib/fa/paper-plane';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

const VideoPlayer = ({
  videoURL,
  text,
  maxReplays,
  onReplayClick,
  onStart,
  onDone,
  onNext,
  speech,
  videoPlaying,
  useButtonLabels,
  useClearButtons,
  replayDisabled,
  suppressReplayOverlay,
  // When undefined, Video falls back to iPad session flag (see unmountWhenDone below).
  unmountWhenDone,
}) => {
  const [replayCount, setReplayCount] = useState(0);
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const onReplay = () => {
    if (replayDisabled) return;

    setReplayCount(replayCount + 1);
    setShowVideoOverlay(false);
    setIsPlaying(true);
    onReplayClick && onReplayClick();
    onStart && onStart();
  };

  const onVideoDone = () => {
    setIsPlaying(false);
    if (!suppressReplayOverlay && (replayCount < maxReplays || onNext)) {
      setShowVideoOverlay(true);
    }
    onDone && onDone();
  };

  // On start
  useEffect(() => {
    setIsPlaying(videoPlaying);
    if (videoPlaying) {
      setShowVideoOverlay(false);
      onStart && onStart();
    }
  }, [videoPlaying]);

  useEffect(() => {
    setReplayCount(0);
  }, [maxReplays, videoURL]);

  // MMC may set suppressReplayOverlay after overlay is already visible (e.g. item transition); hide it.
  useEffect(() => {
    if (suppressReplayOverlay) {
      setShowVideoOverlay(false);
    }
  }, [suppressReplayOverlay]);

  return (
    <div className="videoWrapper">
      <Video
        videoURL={videoURL}
        text={text}
        playVideo={isPlaying}
        allowReplay={true}
        onDone={onVideoDone}
        unmountWhenDone={
          unmountWhenDone !== undefined ? unmountWhenDone : getUserData().sessionData.isiPad
        }
        key={`TheOnly${text}Video`}
        speech={speech}
      />
      {showVideoOverlay && (
        <div className="replayOverlay">
          {replayCount < maxReplays && (
            <div className={"videoPlayerButtonContainer fixedInPlace"}>
              <div 
                className={`readAloudButton replay ${useClearButtons ? 'clear' : ''}`}
                aria-label="Replay video" 
                {...doNotUseAccessibleStaticElementInteractions({onClick: onReplay})}>
                  <FaRepeat size="70" className="buttonSvg replay" />
                {useButtonLabels && <div className="buttonLabel replay">Replay</div>}
              </div>
            </div>
          )}
          {onNext && (
            <div className={"videoPlayerButtonContainer fixedInPlace"}>
              <div 
                className={`readAloudButton next ${useClearButtons ? 'clear' : ''}`}
                aria-label="Next" 
                  {...doNotUseAccessibleStaticElementInteractions({onClick: onNext})}>
                <FaPaperPlane size="70" className="buttonSvg next" />
                {useButtonLabels && <div className="buttonLabel next">Next</div>}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
